module.exports = __webpack_public_path__ + "static/media/fundo.e76370da.png";